export default (axios) => ({
  fetchBlackList() {
    return axios.get("/admin/phones/black-list");
  },
  removeFromBlackList(id) {
    if (!id) throw new Error("Id not passed");
    return axios.delete(`/admin/phones/black-list/${id}`);
  },
});
